interface HeaderProps {
  scrolled: boolean;
}

export default function Header({ scrolled }: HeaderProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-5 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img 
            src="https://public.readdy.ai/ai/img_res/8b1308fd-6fa9-4e78-9243-fa55b35c3949.png" 
            alt="RITMO Logo" 
            className="h-10 w-10 object-contain"
          />
          <span className={`text-xl font-medium transition-colors ${scrolled ? 'text-gray-900' : 'text-white'}`}>
            RITMO, d. o. o.
          </span>
        </div>
        
        <nav className="flex items-center gap-8">
          <button
            onClick={() => scrollToSection('about')}
            className={`text-sm font-medium transition-colors cursor-pointer hover:opacity-70 ${
              scrolled ? 'text-gray-700' : 'text-white'
            }`}
          >
            About Us
          </button>
          <span className={`${scrolled ? 'text-gray-300' : 'text-white/30'}`}>|</span>
          <button
            onClick={() => scrollToSection('products')}
            className={`text-sm font-medium transition-colors cursor-pointer hover:opacity-70 ${
              scrolled ? 'text-gray-700' : 'text-white'
            }`}
          >
            Products
          </button>
          <span className={`${scrolled ? 'text-gray-300' : 'text-white/30'}`}>|</span>
          <button
            onClick={() => scrollToSection('features')}
            className={`text-sm font-medium transition-colors cursor-pointer hover:opacity-70 ${
              scrolled ? 'text-gray-700' : 'text-white'
            }`}
          >
            Features
          </button>
          <span className={`${scrolled ? 'text-gray-300' : 'text-white/30'}`}>|</span>
          <button
            onClick={() => scrollToSection('contact')}
            className={`text-sm font-medium transition-colors cursor-pointer hover:opacity-70 ${
              scrolled ? 'text-gray-700' : 'text-white'
            }`}
          >
            Contact
          </button>
        </nav>
      </div>
    </header>
  );
}